import { Alert } from "@material-ui/lab";
import { FC } from "react";
import {
  Edit,
  EditProps,
  FormGroupContextProvider,
  FormWithRedirect,
  maxValue,
  minValue,
  NumberInput,
  required,
} from "react-admin";

import CustomCard from "../../components/CustomCard";
import CustomToolbar from "../../components/CustomToolbar";
import FormWrapper from "../../components/FormWrapper";
import ImageUploadInput from "../../components/ImageUploadInput";
import Loader from "../../components/Loader";
import Spacing from "../../components/Spacing";
import useDefaultDisabledStyles from "../../hooks/useDefaultDisabledStyles";
import { FormGroupNames } from "../../types/reactAdmin.types";
import { AppResource } from "../../types/resource.types";
import { int, validateFileSize } from "../../utils/validators";
import useBrandCategoriesLocalizations from "./utils/useBrandCategoriesLocalizations";
import useCanUpdateBrandCategory from "./utils/useCanUpdateBrandCategory";

const CustomForm: FC<CustomEditProps> = (props) => {
  const localizedInputs = useBrandCategoriesLocalizations(props);
  const { canUpdateCategory, loading } = useCanUpdateBrandCategory(props.record.id);
  const { defaultDisabledStyles } = useDefaultDisabledStyles();

  return (
    <FormWrapper>
      <Loader loading={loading}>
        <FormGroupContextProvider name={FormGroupNames.brandCategoriesEdit}>
          <FormWithRedirect
            {...props}
            redirect={`/${AppResource.brandsCategories}`}
            render={(formProps) => {
              return (
                <form>
                  <CustomCard title="Details">
                    <Spacing itemStyle={!canUpdateCategory ? defaultDisabledStyles : {}}>{localizedInputs}</Spacing>
                    <NumberInput
                      variant="outlined"
                      source="sortIndex"
                      style={{ width: "100%" }}
                      validate={[required(), int(), minValue(0), maxValue(100)]}
                    />
                  </CustomCard>

                  <CustomCard title="Image (png/should be transparent)">
                    <ImageUploadInput
                      source="image"
                      accept="image/png"
                      validate={[required(), validateFileSize("image")]}
                    />
                  </CustomCard>
                  <CustomToolbar {...formProps} formName={FormGroupNames.brandCategoriesEdit} />
                </form>
              );
            }}
          />
        </FormGroupContextProvider>
      </Loader>
    </FormWrapper>
  );
};

const BrandCategoriesEdit: FC<EditProps> = (props) => {
  return (
    <Edit {...props} component="section">
      <CustomForm sanitizeEmptyValues={false} />
    </Edit>
  );
};

interface CustomEditProps {
  [key: string]: any;
}

export default BrandCategoriesEdit;
